// https://developer.mozilla.org/en-US/docs/Web/API/Location
export const isProduction =
  window.location.hostname === 'platform.spacecubed.now.sh' ||
  window.location.hostname === 'platform.spacecubed.com'
